import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestNews() {
  const { t } = useTranslation();
  const [visibleCount, setVisibleCount] = useState(6);

  const latestArticles = articles.sort((a, b) =>
    new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
  );

  const displayedArticles = latestArticles.slice(0, visibleCount);
  const hasMore = visibleCount < latestArticles.length;

  return (
    <section id="latest-news" className="py-14 md:py-18 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            {t('latestNews.title')}
            <span className="text-primary-500">{t('latestNews.titleHighlight')}</span>
          </h2>
          <p className="text-foreground-500 text-sm mt-2">{t('latestNews.subtitle')}</p>
        </div>

        <div className="flex flex-col gap-4" data-product-shop="">
          {displayedArticles.map((article) => (
            <ArticleCard key={article.id} {...article} variant="default" />
          ))}
        </div>

        {hasMore && (
          <div className="text-center mt-8">
            <button
              onClick={() => setVisibleCount((prev) => prev + 6)}
              className="px-8 py-3 rounded-full bg-background-100 border border-background-300 text-foreground-700 font-medium text-sm whitespace-nowrap hover:bg-background-200 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              {t('latestNews.loadMore')}
              <i className="ri-arrow-down-line ml-1.5"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}